import { render, staticRenderFns } from "./adminQuestionnaires.vue?vue&type=template&id=5e2792cf"
import script from "./adminQuestionnaires.vue?vue&type=script&lang=js"
export * from "./adminQuestionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports